import Normal from './Normal';
import Important from './Important';
import Info from './Info';

export { Normal, Important, Info };
